import React from "react";
import styled, { keyframes } from "styled-components";

import Partner1 from "../../assets/images/partner1.png";
import Partner2 from "../../assets/images/partner2.png";
import Partner3 from "../../assets/images/partner3.png";

const slide = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const ImageContainer = styled.div`
  display: flex;
  width: 1000%;
  animation: ${slide} 30s linear infinite;
  @media (max-width: 777px) {
    animation: ${slide} 15s linear infinite;
  }
`;

const ImageWrapper = styled.div`
  width: 100vw;
  overflow: hidden;
  display: flex;
  margin-top: 5rem;
  margin-bottom: 5rem;
`;

const MovingImage = styled.img`
  width: auto;
  height: 8rem;
  margin-left: 5rem;
`;

const images = [
  { src: Partner1, alt: "Partner 1", id: 1 },
  { src: Partner2, alt: "Partner 2", id: 2 },
  { src: Partner3, alt: "Partner 3", id: 3 },
  { src: Partner1, alt: "Partner 11", id: 4 },
  { src: Partner2, alt: "Partner 22", id: 5 },
  { src: Partner3, alt: "Partner 33", id: 6 },
  { src: Partner1, alt: "Partner 111", id: 7 },
  { src: Partner2, alt: "Partner 222", id: 8 },
  { src: Partner3, alt: "Partner 333", id: 9 },
  { src: Partner1, alt: "Partner 1111", id: 10 },
  { src: Partner2, alt: "Partner 2222", id: 11 },
  { src: Partner3, alt: "Partner 3333", id: 12 },
  { src: Partner1, alt: "Partner 11111", id: 13 },
  { src: Partner2, alt: "Partner 22222", id: 14 },
  { src: Partner3, alt: "Partner 33333", id: 15 },
];

const ImageSlider = () => {
  return (
    <ImageWrapper>
      <ImageContainer>
        {images.concat(images).map((image) => (
          <MovingImage key={image.id} src={image.src} alt={image.alt} />
        ))}
      </ImageContainer>
    </ImageWrapper>
  );
};

export default ImageSlider;
